import { c as _c } from "react/compiler-runtime";
import { APICreatedCliToken } from '../../../../../../../../../typings/CliClient.interface';
import Text from '../../../../../common/base/Text';
import CopyableField from '../../../../../common/CopyableField';
import { Div } from '../../../../../common/helpers/StyledUtils';
import Modal from '../../../../../common/Modal';
interface KeyCreatedModalProps {
  cli_key: APICreatedCliToken;
  onClose: () => void;
}
const KeyCreatedModal: React.FC<KeyCreatedModalProps> = t0 => {
  const $ = _c(19);
  const {
    cli_key,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      direction: "column",
      gap: 4
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      direction: "column",
      gap: 1
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== cli_key.device_name) {
    t3 = <Text semi={true} size="xs" muted={true}>{cli_key.device_name}</Text>;
    $[2] = cli_key.device_name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== cli_key.key) {
    t4 = <CopyableField value={cli_key.key} mono={true} />;
    $[4] = cli_key.key;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Div flex={t2}>{t3}{t4}</Div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      direction: "column",
      gap: 1
    };
    t7 = <Text semi={true} size="xs" muted={true}>Log in to the CLI with it</Text>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  const t8 = `hookdeck login --cli-key ${cli_key.key}`;
  let t9;
  if ($[11] !== t8) {
    t9 = <Div flex={t6}>{t7}<CopyableField value={t8} mono={true} variant="command_list" /></Div>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t5 || $[14] !== t9) {
    t10 = <Div flex={t1} data-testid="created-key">{t5}{t9}</Div>;
    $[13] = t5;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== onClose || $[17] !== t10) {
    t11 = <Modal title="Key created" submit_label="Done" onSubmit={onClose} onClose={onClose}>{t10}</Modal>;
    $[16] = onClose;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
export default KeyCreatedModal;